module.exports = __webpack_public_path__ + "img/00031.76beec67.webp";